import angular from 'angular'
import React from 'react'
import { reactular } from '@vendhq/reactular'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import {
  QuickReceipt,
  QuickReceiptListItem,
  QuickReceiptDateItem,
  QuickReceiptRegisterItem,
} from '../quick-receipt/QuickReceipt'

interface StoreCreditIssueData {
  amount: string
  date: string
  customerInfo: string
  balance: string
  type: string
  username: string
}

interface StoreCreditIssueReceiptProps {
  data: StoreCreditIssueData
}

export const StoreCreditIssueReceipt: React.FC<StoreCreditIssueReceiptProps> = ({
  data,
}) => {
  const vdCurrencyFilter = useVdCurrencyFilter()

  return (
    <QuickReceipt
      title={data.type}
      subTitle={vdCurrencyFilter(data.amount)}
      items={
        <>
          <QuickReceiptDateItem value={data.date} />
          <QuickReceiptListItem label="Customer" value={data.customerInfo} />
          <QuickReceiptListItem
            label="Balance"
            value={vdCurrencyFilter(data.balance)}
          />
          <QuickReceiptListItem label="Served By" value={data.username} />
          <QuickReceiptRegisterItem />
        </>
      }
    />
  )
}

angular
  .module('webregister.components')
  .component(
    'wrPrintStoreCreditIssueReceipt',
    reactular(StoreCreditIssueReceipt, ['data'], 'reactWrapper')
  )
